import React from 'react';
import { Text } from '@common/components';
import { ColorsType } from '@common/tokens';
import { StaffingRequestAssignmentState as AssignmentState } from '@common/graphql';

const DEFAULT_COLOR: ColorsType = 'steelDarkest';

const COLOR_MAP: Partial<Record<AssignmentState, ColorsType>> = {
  onboarding: 'harvestGold',
  cleared: 'grassLighter',
  working: 'grass',
  completed: 'grassDarkest',
  cancelled: 'steelDarkest',
  extended: 'grass',
  extension_pending: 'harvestGold',
  extension_sent: 'harvestGold',
  extension_change_requested: 'harvestGold',
};

const LABEL_MAP: Partial<Record<AssignmentState, string>> = {
  onboarding: 'Onboarding',
  cleared: 'Cleared',
  working: 'Working',
  completed: 'Completed',
  cancelled: 'Cancelled',
  extended: 'Extended',
  extension_pending: 'Extension Pending',
  extension_sent: 'Extension Sent',
  extension_change_requested: 'Ext Change Requested',
};

const formatFallbackLabel = (state: string) =>
  state.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export const StaffingRequestAssignmentState = ({
  state,
}: {
  state: AssignmentState | string;
}) => {
  const color = COLOR_MAP[state as AssignmentState] ?? DEFAULT_COLOR;
  const label =
    LABEL_MAP[state as AssignmentState] ?? formatFallbackLabel(state);

  return (
    <Text weight="bolder" color={color}>
      {label}
    </Text>
  );
};
